var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 1C8.16345 1 1 8.16345 1 17C1 25.8366 8.16345 33 17 33C25.8366 33 33 25.8366 33 17C33 12.2613 30.9399 8.0038 27.6667 5.0741",
    stroke: "#B2D235",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9998 10.2787C17.2338 10.2787 17.4253 10.0872 17.4253 9.85319V7.42553C17.4253 7.19149 17.2338 7 16.9998 7C16.7657 7 16.5742 7.19149 16.5742 7.42553V9.85277C16.5742 10.0868 16.7657 10.2787 16.9998 10.2787Z",
    fill: "#B2D235",
    stroke: "#B2D235",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9998 23.7217C16.7657 23.7217 16.5742 23.9132 16.5742 24.1472V26.5749C16.5742 26.8089 16.7657 27.0004 16.9998 27.0004C17.2338 27.0004 17.4253 26.8089 17.4253 26.5749V24.1476C17.4253 23.9136 17.2338 23.7217 16.9998 23.7217Z",
    fill: "#B2D235",
    stroke: "#B2D235",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5305 9.92981C10.365 9.76428 10.0944 9.76428 9.92884 9.92981C9.7633 10.0953 9.7633 10.366 9.92884 10.5315L11.645 12.2473C11.8105 12.4128 12.0812 12.4128 12.2467 12.2477C12.4118 12.0822 12.4118 11.8115 12.2463 11.646L10.5305 9.92981Z",
    fill: "#B2D235",
    stroke: "#B2D235",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3544 21.7531C22.1889 21.5876 21.9182 21.5876 21.7527 21.7527C21.5876 21.9186 21.5876 22.1884 21.7531 22.3544L23.4689 24.0706C23.6344 24.2361 23.905 24.2361 24.0706 24.0706C24.2361 23.9046 24.2361 23.6344 24.0706 23.4689L22.3544 21.7531Z",
    fill: "#B2D235",
    stroke: "#B2D235",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2787 16.9998C10.2787 16.7657 10.0872 16.5742 9.85319 16.5742H7.42553C7.19149 16.5742 7 16.7657 7 16.9998C7 17.2338 7.19149 17.4253 7.42553 17.4253H9.85319C10.0872 17.4253 10.2787 17.2338 10.2787 16.9998Z",
    fill: "#B2D235",
    stroke: "#B2D235",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5758 16.5742H24.1482C23.9141 16.5742 23.7227 16.7657 23.7227 16.9998C23.7227 17.2338 23.9141 17.4253 24.1482 17.4253H26.5758C26.8099 17.4253 27.0014 17.2338 27.0014 16.9998C27.0014 16.7657 26.8099 16.5742 26.5758 16.5742Z",
    fill: "#B2D235",
    stroke: "#B2D235",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.645 21.7528L9.92884 23.4685C9.7633 23.6341 9.7633 23.9043 9.92884 24.0702C10.0944 24.2358 10.365 24.2358 10.5305 24.0702L12.2463 22.3541C12.4118 22.1881 12.4118 21.9183 12.2467 21.7524C12.0812 21.5877 11.8105 21.5877 11.645 21.7528Z",
    fill: "#B2D235",
    stroke: "#B2D235",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3547 12.2473L24.0717 10.5315C24.2373 10.366 24.2373 10.0953 24.0717 9.92981C23.9062 9.76428 23.6356 9.76428 23.47 9.92981L21.7534 11.646C21.5875 11.8115 21.5875 12.0822 21.753 12.2477C21.9185 12.4124 22.1892 12.4124 22.3547 12.2473Z",
    fill: "#B2D235",
    stroke: "#B2D235",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.017 16.8564C19.771 16.6802 19.4919 16.5381 19.1766 16.4317C18.8629 16.3266 18.5404 16.2356 18.2097 16.1602C17.9446 16.0985 17.6859 16.0428 17.4276 15.9883V14.2134C17.6178 14.2522 17.7936 14.3109 17.9523 14.3943C18.2514 14.5475 18.4174 14.8449 18.4485 15.2815H20.6068C20.5642 14.7692 20.434 14.3458 20.2161 14.01C19.9966 13.6747 19.7225 13.4053 19.3914 13.2019C19.0608 13.0002 18.6859 12.856 18.2646 12.7705C17.991 12.7147 17.7106 12.6841 17.4268 12.6649V11.6807H16.5757V12.6594C16.2625 12.676 15.9527 12.7053 15.6497 12.7615C15.2234 12.8419 14.8395 12.9811 14.4987 13.1781C14.1578 13.3751 13.8829 13.6475 13.6749 13.993C13.468 14.3407 13.3642 14.7751 13.3642 15.2968C13.3642 15.659 13.4383 15.9658 13.5876 16.2151C13.7366 16.467 13.9336 16.6747 14.1787 16.8407C14.4246 17.0058 14.7038 17.1381 15.0191 17.2398C15.3332 17.3428 15.6557 17.4275 15.9863 17.5041C16.1936 17.5479 16.3897 17.5905 16.5757 17.6334V19.787C16.5583 19.7838 16.5409 19.7809 16.5234 19.7781L16.5233 19.7781L16.5232 19.7781C16.4907 19.7727 16.458 19.7674 16.4259 19.7594C16.2174 19.7053 16.0344 19.6236 15.874 19.5117C15.7136 19.4002 15.5838 19.2547 15.4825 19.0794C15.3804 18.9032 15.3297 18.6922 15.3297 18.4487H13.1719C13.1936 18.9905 13.3191 19.4505 13.548 19.8228C13.777 20.196 14.0697 20.4985 14.4276 20.727C14.7842 20.9564 15.1923 21.1194 15.6502 21.2143C15.9536 21.2777 16.2634 21.3126 16.5761 21.3347V22.319H17.4272V21.3385C17.7697 21.3194 18.108 21.2836 18.4404 21.2122C18.8932 21.1177 19.2974 20.9573 19.6489 20.7334C19.9995 20.51 20.2846 20.213 20.5034 19.8466C20.7225 19.4777 20.8314 19.0219 20.8314 18.4785C20.8314 18.0947 20.7566 17.773 20.6072 17.5117C20.4578 17.2505 20.2617 17.0313 20.017 16.8564ZM16.4421 15.7368C16.2025 15.6564 16.0076 15.5517 15.8595 15.4249C15.7093 15.2973 15.6361 15.1317 15.6361 14.9287C15.6361 14.7581 15.6778 14.6228 15.7638 14.5224C15.848 14.4202 15.9519 14.3436 16.0757 14.2905C16.1978 14.2368 16.3332 14.2019 16.4825 14.1862C16.5017 14.1843 16.5188 14.1836 16.536 14.1829H16.536C16.5493 14.1823 16.5627 14.1818 16.577 14.1807V15.7768C16.5547 15.7698 16.5314 15.7631 16.5085 15.7565C16.4855 15.7499 16.463 15.7434 16.4421 15.7368ZM18.0561 19.6053C18.2008 19.5262 18.3204 19.4198 18.4174 19.287C18.5144 19.1534 18.5604 18.9849 18.5595 18.7832C18.5595 18.613 18.5012 18.4658 18.3842 18.3436C18.2668 18.2207 18.0987 18.1122 17.8804 18.0156C17.7493 17.9577 17.5949 17.9036 17.4268 17.8522V19.8075C17.4442 19.8045 17.4615 19.8019 17.4788 19.7993C17.5116 19.7943 17.5442 19.7893 17.5774 19.7824C17.7536 19.7445 17.9132 19.6858 18.0561 19.6053Z",
    fill: "#B2D235"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification1);
export default __webpack_public_path__ + "static/media/notification1.1009d590.svg";
export { ForwardRef as ReactComponent };